export * from './chains'
export * from './chains-base-gas'
export * from './nft'

export const solanaBaseTxCost = 0.000005 // SOL
